import DOMPurify from 'dompurify';

/**
 * Strip ALL HTML tags, returning only the text content.
 * Useful when the output must be plain text (e.g. user-facing error messages
 * that pass through a markdown/HTML rendering pipeline).
 */
export function stripHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
}
